import React from 'react';
import PropTypes from 'prop-types';
import styles from './Preview.module.scss.js';

var Preview = function Preview(_ref) {
  var children = _ref.children,
    componentDecorator = _ref.componentDecorator;
  function addPropsToChildren(children, fn) {
    return React.Children.map(children, function (child) {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }
      if (child.props.children) {
        child = /*#__PURE__*/React.cloneElement(child, {
          children: addPropsToChildren(child.props.children, fn)
        });
      }
      return fn(child);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    className: styles.isPreview
  }, componentDecorator ? addPropsToChildren(children, componentDecorator) : children);
};
Preview.propTypes = {
  children: PropTypes.node.isRequired,
  componentDecorator: PropTypes.func
};

export { Preview as default };
//# sourceMappingURL=index.js.map
